import { useEffect, useContext } from 'react';
import useFetchCoinflipGames, {
    reorderGames,
} from '@hooks/useFetchCoinflipGames';
import PageEntranceAnimation from '@components/page-entrance-animation';
import { SocketContext } from '@context/socket';

import CreateGame from '@components/coinflip/pieces/create-game';
import CoinflipGameList from '@components/coinflip/pieces/coinflip-list';
import Layout from '@components/layout';
import useReduxState from '@hooks/useReduxState';

const modules: JSX.Element[] = [
    <CreateGame key="create-game" />,
    <CoinflipGameList key="coinflip-list" />,
];

export default function CoinFlipGame(): JSX.Element {
    const [games, setGames] = useReduxState((state) => state.coinflipData);
    const socket = useContext(SocketContext);
    const fetched: boolean = JSON.stringify(games) !== '{}';

    // Computed state variables
    const getGames = useFetchCoinflipGames();

    useEffect(() => {
        getGames();
    }, []);

    useEffect(() => {
        socket.emit('coinflip');
        socket.on('coinflip-games', (gms) => {
            setGames({
                type: 'SET_COINFLIP_GAMES',
                arg: {
                    ...reorderGames(gms),
                },
            });
        });
        socket.on('Cancel-CoinflipGame', (uid) => {
            setGames({
                type: 'REMOVE_COINFLIP_GAME',
                arg: {
                    gameUid: uid,
                },
            });
        });
    }, [socket]);

    return (
        <Layout title="coinflip" withSpacing {...{ fetched }}>
            <PageEntranceAnimation {...{ modules, fetched }} />
        </Layout>
    );
}
